import { generatePath } from "react-router-dom";
import Link from "./Link";

export default class SpMerchantLink extends Link {
  constructor(merchantId, name, icon, path, component, authenticationName, spMerchantId) {
    super(merchantId, name, icon, path, component, authenticationName);
    this.spMerchantId = spMerchantId;
  }

  getLink() {
    return generatePath(this.path, { merchantId: this.merchantId, spMerchantId: this.spMerchantId });
  }
}
